/* Saunagids: kaart (Leaflet + PDOK), postcode zoeken (PDOK Locatieserver), filters, sorteren en Google reviews.
   De lijst met sauna's staat al in de HTML (goed voor SEO); dit script leest de kaartjes uit en voegt alleen interactie toe. */
(function () {
  var TEGELS = 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/pastel/EPSG:3857/{z}/{x}/{y}.png';
  var BRON = 'Kaart: <a href="https://www.kadaster.nl" target="_blank" rel="noopener">Kadaster</a> / PDOK';

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function km(a, b) {
    var R = 6371, r = Math.PI / 180, dLa = (b[0] - a[0]) * r, dLo = (b[1] - a[1]) * r;
    var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  /* ---------- kaart ---------- */
  function pin(cls) { var s = cls === 'groot' ? 30 : 24; return L.divIcon({ className: '', html: '<div class="sg-pin ' + (cls || '') + '">&#8203;</div>', iconSize: [s, s], iconAnchor: [s / 2, s / 2], popupAnchor: [0, -s / 2] }); }
  function maakKaart(el) {
    var map = L.map(el, { scrollWheelZoom: false, attributionControl: true });
    L.tileLayer(TEGELS, { maxZoom: 19, minZoom: 6, attribution: BRON }).addTo(map);
    map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
    map.on('focus', function () { map.scrollWheelZoom.enable(); });
    map.on('blur', function () { map.scrollWheelZoom.disable(); });
    return map;
  }
  function popup(k) {
    return '<a href="' + esc(k.dataset.url) + '">' + esc(k.dataset.naam) + '</a><br>' + esc(k.dataset.plaats) +
      (k.dataset.prijs ? '<br>vanaf €' + Number(k.dataset.prijs).toFixed(2).replace('.', ',').replace(',00', '') : '');
  }

  /* ---------- lijst met filters ---------- */
  function score(k) {
    var f = (k.dataset.fac || '').split(' ').filter(Boolean).length, p = 0, prijs = k.dataset.prijs ? Number(k.dataset.prijs) : null;
    if (prijs != null && k.dataset.prive !== '1') p = Math.max(0, 4 - prijs / 15);
    return f + p + (k.dataset.kleding === 'beide' ? 1 : 0) + (prijs != null ? 1 : 0);
  }
  function past(k, act) {
    return act.every(function (f) {
      if (f === 'prive') return k.dataset.prive === '1';
      if (f === 'textiel') return k.dataset.kleding === 'textiel' || k.dataset.kleding === 'beide';
      if (f === 'prijs') return !!k.dataset.prijs;
      return (' ' + k.dataset.fac + ' ').indexOf(' ' + f + ' ') > -1;
    });
  }

  function initLijst(root) {
    var lijst = $('[data-sg-lijst]', root); if (!lijst) return;
    var kaartjes = $$('.sg-kaartje', lijst);
    var sortSel = $('[data-sg-sort]', root);
    var chips = $$('.sg-chip', root);
    var leeg = $('[data-sg-leeg]', root);
    var meer = $('[data-sg-meer]', root);
    var titel = $('[data-sg-restitel]', root);
    var max = Number(lijst.dataset.max || 0);
    var plek = null;
    kaartjes.forEach(function (k) { k._sc = score(k); });

    var mapEl = $('[data-sg-map]', root), map = null, lagen = null, jijLaag = null;
    if (mapEl && window.L) {
      map = maakKaart(mapEl);
      lagen = L.layerGroup().addTo(map);
    }

    function teken(zichtbaar) {
      if (!map) return;
      lagen.clearLayers();
      var pts = [];
      zichtbaar.forEach(function (k) {
        var ll = [Number(k.dataset.lat), Number(k.dataset.lon)];
        if (!ll[0]) return;
        pts.push(ll);
        L.marker(ll, { icon: pin(k.dataset.top === '1' ? 'top' : ''), title: k.dataset.naam, keyboard: true }).bindPopup(popup(k)).addTo(lagen);
      });
      if (jijLaag) { map.removeLayer(jijLaag); jijLaag = null; }
      if (plek) { jijLaag = L.marker(plek.pt, { icon: pin('jij'), title: 'Jouw zoekpunt', zIndexOffset: 1000 }).bindPopup('Jouw zoekpunt: ' + esc(plek.naam)).addTo(map); pts.push(plek.pt); }
      if (pts.length === 1) map.setView(pts[0], 13);
      else if (pts.length) map.fitBounds(pts, { padding: [28, 28], maxZoom: 14 });
      else map.setView([52.37, 4.9], 9);
    }

    function toon() {
      var act = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }).map(function (c) { return c.dataset.f; });
      var sort = sortSel ? sortSel.value : 'score';
      kaartjes.forEach(function (k) {
        k._d = plek ? km(plek.pt, [Number(k.dataset.lat), Number(k.dataset.lon)]) : null;
        var a = $('[data-sg-afstand]', k);
        if (a) a.textContent = k._d != null ? k._d.toFixed(1).replace('.', ',') + ' km' : '';
      });
      var l = kaartjes.filter(function (k) { return past(k, act); });
      l.sort(function (a, b) {
        if (sort === 'afstand' && plek) return a._d - b._d;
        if (sort === 'prijs') return (a.dataset.prijs ? Number(a.dataset.prijs) : 9999) - (b.dataset.prijs ? Number(b.dataset.prijs) : 9999);
        if (sort === 'naam') return a.dataset.naam.localeCompare(b.dataset.naam, 'nl');
        return b._sc - a._sc;
      });
      var zichtbaar = max ? l.slice(0, max) : l;
      kaartjes.forEach(function (k) { k.hidden = true; });
      zichtbaar.forEach(function (k) { k.hidden = false; lijst.appendChild(k); });
      if (leeg) leeg.hidden = l.length > 0;
      if (meer) { var rest = l.length - zichtbaar.length; meer.hidden = rest <= 0; meer.textContent = rest + " sauna's verder weg. Gebruik de filters of kies je provincie."; }
      if (titel) titel.textContent = plek ? (plek.titel || "De beste sauna's in " + plek.naam) : titel.dataset.std;
      teken(zichtbaar);
    }

    chips.forEach(function (c) { c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); toon(); }); });
    if (sortSel) sortSel.addEventListener('change', toon);

    /* zoeken op postcode of plaats (heel Nederland, via PDOK) */
    var form = $('[data-sg-zoek]', root), melding = $('[data-sg-melding]', root);
    function zet(p, tekst) {
      plek = p;
      if (sortSel) { if (!$('option[value="afstand"]', sortSel)) sortSel.insertAdjacentHTML('afterbegin', '<option value="afstand">Afstand</option>'); sortSel.value = 'afstand'; }
      if (melding) melding.textContent = tekst;
      toon();
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = form.querySelector('input').value.trim(); if (!q) return;
        var c = q.replace(/\s+/g, '').toUpperCase(), url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fl=weergavenaam,centroide_ll,woonplaatsnaam,type&';
        if (/^\d{4}$/.test(c)) url += 'fq=type:postcode&q=postcode:' + c + '*';
        else if (/^\d{4}[A-Z]{2}$/.test(c)) url += 'fq=type:postcode&q=' + c;
        else url += 'fq=type:(woonplaats OR gemeente)&q=' + encodeURIComponent(q);
        if (melding) melding.textContent = 'Zoeken...';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          var doc = d && d.response && d.response.docs && d.response.docs[0];
          var m = doc && /POINT\(([\d.]+) ([\d.]+)\)/.exec(doc.centroide_ll);
          if (!m) { if (melding) melding.textContent = 'We vinden "' + q + '" niet. Probeer een postcode, bijvoorbeeld 1017.'; return; }
          var naam = (doc.type === 'postcode' ? (doc.woonplaatsnaam || '') : doc.weergavenaam.split(',')[0]).trim();
          zet({ pt: [Number(m[2]), Number(m[1])], naam: naam }, 'Gesorteerd op afstand vanaf ' + naam + '.');
        }).catch(function () { if (melding) melding.textContent = 'Zoeken lukt nu even niet. Probeer het zo opnieuw.'; });
      });
      var loc = $('[data-sg-locatie]', root);
      if (loc) loc.addEventListener('click', function () {
        if (!navigator.geolocation) { melding.textContent = 'Je browser deelt geen locatie. Vul je postcode in.'; return; }
        melding.textContent = 'Locatie ophalen...';
        navigator.geolocation.getCurrentPosition(function (p) { zet({ pt: [p.coords.latitude, p.coords.longitude], naam: 'jouw locatie', titel: "De beste sauna's bij jou in de buurt" }, 'Gesorteerd op afstand vanaf jouw locatie.'); },
          function () { melding.textContent = 'Locatie delen is geweigerd. Vul je postcode in.'; }, { timeout: 10000 });
      });
    }
    toon();
  }

  /* ---------- kaart met één sauna ---------- */
  function initEnkel(el) {
    if (!window.L) return;
    var ll = [Number(el.dataset.lat), Number(el.dataset.lon)]; if (!ll[0]) return;
    var map = maakKaart(el);
    map.setView(ll, 14);
    L.marker(ll, { icon: pin('groot'), title: el.dataset.naam }).bindTooltip(esc(el.dataset.naam), { permanent: true, direction: 'top', offset: [0, -16], className: 'sg-label' }).addTo(map);
  }

  /* ---------- Google reviews (live, nooit opgeslagen) ---------- */
  function sterren(n) { var r = Math.round(n); return '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r); }
  function initGoogle(el) {
    var key = el.dataset.key; if (!key) return;
    var gestart = false;
    function start() {
      if (gestart) return; gestart = true;
      window.__sgGoogle = window.__sgGoogle || new Promise(function (ok, nok) {
        window.__sgGoogleKlaar = ok;
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&language=nl&region=NL&loading=async&callback=__sgGoogleKlaar';
        s.async = true; s.onerror = nok; document.head.appendChild(s);
      });
      window.__sgGoogle.then(function () { return google.maps.importLibrary('places'); }).then(function (lib) {
        var velden = ['id', 'displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI'];
        if (el.dataset.placeId) {
          var p = new lib.Place({ id: el.dataset.placeId, requestedLanguage: 'nl' });
          return p.fetchFields({ fields: velden }).then(function () { return p; });
        }
        return lib.Place.searchByText({
          textQuery: el.dataset.zoek, fields: velden, maxResultCount: 1, language: 'nl', region: 'nl',
          locationBias: { center: { lat: Number(el.dataset.lat), lng: Number(el.dataset.lon) }, radius: 500 }
        }).then(function (r) { return r.places && r.places[0]; });
      }).then(function (p) {
        if (!p || !p.rating) { el.querySelector('[data-sg-g-inhoud]').innerHTML = '<p>Nog geen Google-reviews gevonden voor deze sauna.</p>'; return; }
        var revs = (p.reviews || []).filter(function (r) { return r.text && r.rating >= 4; }).sort(function (a, b) { return b.rating - a.rating; }).slice(0, 3);
        var html = '<div class="sg-g-kop"><span class="sg-g-score num">' + p.rating.toFixed(1).replace('.', ',') + '</span><span><span class="sg-sterren" aria-hidden="true">' + sterren(p.rating) + '</span><br><span class="sg-meer">' + (p.userRatingCount || 0) + ' reviews op Google</span></span></div>';
        html += '<div class="sg-reviews">' + revs.map(function (r) {
          var a = r.authorAttribution || {};
          return '<article class="sg-review"><div class="wie">' + (a.photoURI ? '<img src="' + esc(a.photoURI) + '" alt="" loading="lazy" referrerpolicy="no-referrer">' : '') +
            (a.uri ? '<a href="' + esc(a.uri) + '" target="_blank" rel="noopener nofollow">' + esc(a.displayName) + '</a>' : esc(a.displayName)) +
            ' <span class="wanneer">' + esc(r.relativePublishTimeDescription || '') + '</span></div>' +
            '<div class="sg-sterren" aria-label="' + r.rating + ' van 5 sterren">' + sterren(r.rating) + '</div><p>' + esc(r.text) + '</p></article>';
        }).join('') + '</div>';
        html += '<p class="sg-g-bron">Uitgelichte reviews (4 en 5 sterren) en score live van Google Maps. ' + (p.googleMapsURI ? '<a href="' + esc(p.googleMapsURI) + '" target="_blank" rel="noopener nofollow">Bekijk alle reviews op Google</a>' : '') + '</p>';
        el.querySelector('[data-sg-g-inhoud]').innerHTML = html;
      }).catch(function () { el.querySelector('[data-sg-g-inhoud]').innerHTML = '<p>Google-reviews laden nu niet. Bekijk ze direct op Google Maps.</p>'; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '300px' });
      io.observe(el);
    } else start();
  }

  function init() {
    $$('[data-sg-root]').forEach(initLijst);
    $$('[data-sg-enkel]').forEach(initEnkel);
    $$('[data-sg-google]').forEach(initGoogle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
